import httpStore from "@/api/httpStore.js";

// Proxy del API (POST /ai/assistant_chat): pone la key, el modelo y los
// límites, y reenvía a la Messages API de Claude.
//
// La respuesta vuelve sin camelizar (skipCamelize): sus bloques se reenvían
// tal cual en el siguiente turno, y tool_use_id, stop_reason o los inputs de
// las tools tienen que conservar su nombre.
export function sendAssistantTurn({ system, messages, tools }) {
  return httpStore
    .post(
      "/ai/assistant_chat",
      { system, messages, tools },
      { skipCamelize: true }
    )
    .then(res => res.data);
}

// Stock total de cada código en cada país (USA, Costa Rica, Venezuela), de la
// tabla compartida que reescribe cada país tras sus syncs con Infoauto:
// [{ nkrCode, stores: [{ store, name, enabled, stock, title }] }]
export function getStoresStock(codes) {
  return httpStore
    .get("/products/stores_stock", { params: { codes: codes.join(",") } })
    .then(res => res.data);
}

// Clientes de Infoauto como find_customer, pero sin importar puntos, espacios
// ni mayúsculas ("fd parts" encuentra "F.D. PARTS INC"): { data: [...] }
export function searchCustomers(search, departamentoId, limit) {
  return httpStore
    .get("/infoauto/search_customers", {
      params: { search, departamentoId, limit }
    })
    .then(res => res.data);
}
